import { Component, Input, OnInit } from '@angular/core';
import { MapService } from '../../services/map.service';


@Component({
    selector: 'app-video-screen',
    templateUrl: './video-screen.component.html',
    styleUrls: ['./video-screen.component.scss'],
})
export class VideoScreenComponent implements OnInit {
    @Input() help = true;
    @Input() src = '';
    videoLink = '../../../assets/video/hint/';

    constructor(public mapService: MapService) {
    }

    async ngOnInit() {
        // const videoUrl = await this.downloadFileService.getFileUrl('videos');
        // if (videoUrl.platform === 'mobile') {
        //     let win: any = window;
        //     this.videoLink = win.Ionic.WebView.convertFileSrc(videoUrl.url) + this.src;
        // } else {
        //     this.videoLink = videoUrl.url + this.src;
        // }
    }

}
